import React from 'react';
import ServiceDetails from "../Components/ServiceDetails/ServiceDetails";
import FacadeImg from "../Assests/Images/carousal-deepCleaning.jpg"

function ServiceDeep() {
    return (
        <>


            <ServiceDetails
                ServiceName={"Deep Cleaning"}
                Description={"Elevate your living space or workplace to the next level with our exceptional deep cleaning services. At SaafSafaiWale, we understand that a clean environment is crucial for your health, productivity, and peace of mind. Our dedicated team of cleaning professionals goes above and beyond to ensure every nook and cranny is thoroughly cleaned, sanitized, and refreshed. From eliminating hidden allergens and bacteria to restoring the beauty of your space, our deep cleaning services are designed to exceed your expectations. Let us transform your home or office into a pristine sanctuary where you can thrive and breathe freely. Choose SaafSafaiWale for a deep clean that not only rejuvenates your space but also enhances your overall well-being. Invest in cleanliness, invest in a healthier and happier future."}
                ServiceImage={<img src={FacadeImg} alt='Facade Cleaning'></img>} />
        </>
    )
}

export default ServiceDeep